/*
 * @Description: 路由守卫
 * @Author: 安知鱼
 * @Email: 2268025923@qq.com
 * @Date: 2021-09-30 09:41:33
 * @LastEditTime: 2021-09-30 16:06:59
 * @LastEditors: 安知鱼
 */
import { Router } from 'vue-router'
import { useChangeTitle } from '@/hooks'

export default function (router: Router) {
  router.beforeEach((to) => {
    useChangeTitle(`${to.meta.title} | 德鑫`)
  })
}
